// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .App {
  text-align: center;
} */

.App-logo {
  height: 40vmin;
  pointer-events: none;
}


@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
.css-1chwz6k-MuiPaper-root-MuiDialog-paper {
  background-color: #fff;
  color: rgba(0, 0, 0, 0.87);
  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  border-radius: 4px;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  width: 600px;
  margin: 32px;
  position: relative;
  overflow-y: auto;
  display: flex
;
  flex-direction: column;
  max-height: calc(100% - 64px);
  max-width: undefinedpx;
  /* //width: calc(100% - 64px); */
  width: 50vw !important;
}
.btn-outline-info {
  --bs-btn-color:#ec6e17;
  --bs-btn-border-color:#ec6e17;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg:#ec6e17;
  --bs-btn-hover-border-color:#ec6e17;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg:#ec6e17;
  --bs-btn-active-border-color:#ec6e17;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#ec6e17;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color:#ec6e17;
  --bs-gradient: none;
}
.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}
[type=button], [type=reset], [type=submit], button {
  -webkit-appearance: button;
}
.btn-outline-info {
  --bs-btn-color:#ec6e17 !important;
  --bs-btn-border-color:#ec6e17 !important;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg:#ec6e17 !important;
  --bs-btn-hover-border-color:#ec6e17 !important;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg:#ec6e17 !important;
  --bs-btn-active-border-color:#ec6e17 !important;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color:#ec6e17 !important;
  --bs-btn-disabled-bg: transparent !important;
  --bs-btn-disabled-border-color:#ec6e17 !important;
  --bs-gradient: none;
}
.App-header {
  background-color:#ededed;
  min-height: 100vh;
 /* // display: flex; */
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: black;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.swal2-title {
  color: black!important;
  font-weight: 400!important;
}
.swal2-popup {
  background: #ededed!important;
  border: 1px solid #f7f7f7!important;
}
.swal2-styled.swal2-confirm {
  background-color:#ec6e17 !important;
  color: #fff;
  box-shadow: none !important;
}

.cdk-overlay-pane mat-icon.eye {
  color: #fff;
}



.add_new {
  color: #ffffff;
  display: inline-flex; /* Use inline-flex to enable flexbox alignment */
  align-items: center; /* Center vertically */
  justify-content: center; /* Center horizontally */
  background: #FB8C0C;
  border: 1px solid #fb8c0c;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  position: relative;
  cursor: pointer;
}

.circle {
  font-weight: 400;
  font-size: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,cAAc;EACd,oBAAoB;AACtB;;;AAGA;EACE;IACE,4CAA4C;EAC9C;AACF;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAE1B,6DAA6D;EAC7D,kBAAkB;EAClB,8HAA8H;EAC9H,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAIhB;AACF;EAGE,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,mCAAmC;EACnC,uCAAuC;EACvC,2BAA2B;EAC3B,0BAA0B;EAC1B,oCAAoC;EACpC,4DAA4D;EAC5D,+BAA+B;EAC/B,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,oCAAoC;EACpC,wBAAwB;EACxB,6CAA6C;EAC7C,kCAAkC;EAClC,+CAA+C;EAC/C,wCAAwC;EACxC,4FAA4F;EAC5F,+BAA+B;EAC/B,iFAAiF;EACjF,qBAAqB;EACrB,wDAAwD;EACxD,sCAAsC;EACtC,kCAAkC;EAClC,sCAAsC;EACtC,sCAAsC;EACtC,0BAA0B;EAC1B,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,mEAAmE;EACnE,0CAA0C;EAC1C,kCAAkC;EAClC,iIAAiI;AACnI;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iCAAiC;EACjC,wCAAwC;EACxC,0BAA0B;EAC1B,oCAAoC;EACpC,8CAA8C;EAC9C,uCAAuC;EACvC,2BAA2B;EAC3B,qCAAqC;EACrC,+CAA+C;EAC/C,4DAA4D;EAC5D,0CAA0C;EAC1C,4CAA4C;EAC5C,iDAAiD;EACjD,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,iBAAiB;CAClB,sBAAsB;EACrB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,mCAAmC;AACrC;AACA;EACE,mCAAmC;EACnC,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;;;AAIA;EACE,cAAc;EACd,oBAAoB,EAAE,gDAAgD;EACtE,mBAAmB,EAAE,sBAAsB;EAC3C,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":["/* .App {\n  text-align: center;\n} */\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n.css-1chwz6k-MuiPaper-root-MuiDialog-paper {\n  background-color: #fff;\n  color: rgba(0, 0, 0, 0.87);\n  -webkit-transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  transition: box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  border-radius: 4px;\n  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);\n  width: 600px;\n  margin: 32px;\n  position: relative;\n  overflow-y: auto;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex\n;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  max-height: calc(100% - 64px);\n  max-width: undefinedpx;\n  /* //width: calc(100% - 64px); */\n  width: 50vw !important;\n}\n.btn-outline-info {\n  --bs-btn-color:#ec6e17;\n  --bs-btn-border-color:#ec6e17;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg:#ec6e17;\n  --bs-btn-hover-border-color:#ec6e17;\n  --bs-btn-focus-shadow-rgb: 13, 202, 240;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg:#ec6e17;\n  --bs-btn-active-border-color:#ec6e17;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color:#ec6e17;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color:#ec6e17;\n  --bs-gradient: none;\n}\n.btn {\n  --bs-btn-padding-x: 0.75rem;\n  --bs-btn-padding-y: 0.375rem;\n  --bs-btn-font-family: ;\n  --bs-btn-font-size: 1rem;\n  --bs-btn-font-weight: 400;\n  --bs-btn-line-height: 1.5;\n  --bs-btn-color: var(--bs-body-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-width: var(--bs-border-width);\n  --bs-btn-border-color: transparent;\n  --bs-btn-border-radius: var(--bs-border-radius);\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n  --bs-btn-disabled-opacity: 0.65;\n  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n  font-family: var(--bs-btn-font-family);\n  font-size: var(--bs-btn-font-size);\n  font-weight: var(--bs-btn-font-weight);\n  line-height: var(--bs-btn-line-height);\n  color: var(--bs-btn-color);\n  text-align: center;\n  text-decoration: none;\n  vertical-align: middle;\n  cursor: pointer;\n  -webkit-user-select: none;\n  user-select: none;\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n  border-radius: var(--bs-btn-border-radius);\n  background-color: var(--bs-btn-bg);\n  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n}\n[type=button], [type=reset], [type=submit], button {\n  -webkit-appearance: button;\n}\n.btn-outline-info {\n  --bs-btn-color:#ec6e17 !important;\n  --bs-btn-border-color:#ec6e17 !important;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg:#ec6e17 !important;\n  --bs-btn-hover-border-color:#ec6e17 !important;\n  --bs-btn-focus-shadow-rgb: 13, 202, 240;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg:#ec6e17 !important;\n  --bs-btn-active-border-color:#ec6e17 !important;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color:#ec6e17 !important;\n  --bs-btn-disabled-bg: transparent !important;\n  --bs-btn-disabled-border-color:#ec6e17 !important;\n  --bs-gradient: none;\n}\n.App-header {\n  background-color:#ededed;\n  min-height: 100vh;\n /* // display: flex; */\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: black;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.swal2-title {\n  color: black!important;\n  font-weight: 400!important;\n}\n.swal2-popup {\n  background: #ededed!important;\n  border: 1px solid #f7f7f7!important;\n}\n.swal2-styled.swal2-confirm {\n  background-color:#ec6e17 !important;\n  color: #fff;\n  box-shadow: none !important;\n}\n\n.cdk-overlay-pane mat-icon.eye {\n  color: #fff;\n}\n\n\n\n.add_new {\n  color: #ffffff;\n  display: inline-flex; /* Use inline-flex to enable flexbox alignment */\n  align-items: center; /* Center vertically */\n  justify-content: center; /* Center horizontally */\n  background: #FB8C0C;\n  border: 1px solid #fb8c0c;\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  position: relative;\n  cursor: pointer;\n}\n\n.circle {\n  font-weight: 400;\n  font-size: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
